export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Products',
    icon: 'GridIcon',
    children: [
      {
        title: 'Current Products',
        icon: 'ClockIcon',
        route: 'current-products',
      },
      {
        title: 'All Products',
        icon: 'PackageIcon',
        route: 'full-database',
      },
      {
        title: 'Selection Records',
        icon: 'FileTextIcon',
        route: 'selection-records',
      },
    ],
  },
  {
    title: 'Marketplace',
    icon: 'TrendingUpIcon',
    children: [
      {
        title: 'Dashboard',
        icon: 'LayoutIcon',
        route: 'marketplace-dashboard',
      },
      {
        title: 'Market Reports',
        icon: 'FileTextIcon',
        route: 'marketreports',
      },
    ],
  },
  {
    title: 'Portfolios',
    icon: 'PieChartIcon',
    children: [
      {
        title: 'Saved Portfolios',
        icon: 'BriefcaseIcon',
        route: 'my-portfolios',
      },
      {
        title: 'Upload Spreadsheet',
        icon: 'UploadIcon',
        route: 'upload-spreadsheet',
      },
    ],
  },
  {
    title: 'Providers',
    icon: 'UsersIcon',
    children: [
      {
        title: 'All Providers',
        icon: 'UsersIcon',
        route: 'rankings',
      },
      {
        title: 'Your Enquiries',
        icon: 'MessageSquareIcon',
        route: 'your-enquiries',
      },
    ],
  },
  {
    title: 'Data',
    icon: 'DatabaseIcon',
    children: [
      {
        title: 'Underlyings',
        icon: 'LayersIcon',
        route: 'underlyings',
      },
      {
        title: 'Counterparties',
        icon: 'BriefcaseIcon',
        route: 'issuers',
      },
      {
        title: 'Product Types',
        icon: 'TagIcon',
        route: 'product-types',
      },
    ],
  },
  {
    title: 'Help',
    icon: 'HelpCircleIcon',
    children: [
      {
        title: 'Upgrade to Premium',
        icon: 'BookIcon',
        route: 'learn-more-premium',
      },
      {
        title: 'Structured Edge Guides',
        icon: 'BookOpenIcon',
        route: 'guides',
      },
      {
        title: 'Terms and Conditions',
        icon: 'FileTextIcon',
        route: 'terms-and-conditions',
      },
      {
        title: 'Privacy Policy',
        icon: 'FileTextIcon',
        route: 'privacy-policy',
      },
      {
        title: 'Disclaimer',
        icon: 'FileTextIcon',
        route: 'disclaimer',
      },
      {
        title: 'Contact Us',
        icon: 'PhoneIcon',
        route: 'contact-us',
      },
    ],
  },
  {
    title: 'Previous Platform',
    href: process.env.VUE_APP_CLASSIC_URL,
    icon: 'ExternalLinkIcon',
  },
]
